import { topSidePartOfWeb } from './parts/sideParts'

export const type2Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.moveTo(236, 245) // 左上
  ctx.quadraticCurveTo(259, 245, 280, 257) // 右下
  ctx.quadraticCurveTo(250, 260, 238, 271) // 左上
  ctx.moveTo(251, 287) // 左上
  ctx.quadraticCurveTo(285, 274, 333, 295) // 右下
  ctx.quadraticCurveTo(275, 293, 264, 308) // 左上

  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(238, 241) // 左上
  ctx.quadraticCurveTo(261, 241, 286, 258) // 右下
  ctx.quadraticCurveTo(251, 263, 240, 273) // 左下
  ctx.moveTo(250, 283) // 左上
  ctx.quadraticCurveTo(293, 271, 337, 296) // 右下
  ctx.quadraticCurveTo(280, 298, 266, 310) // 左下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}
